import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import logger from "redux-logger";
import { persistReducer, persistStore } from "redux-persist";
import { encryptTransform } from "redux-persist-transform-encrypt";
import storage from "redux-persist/lib/storage/session";
import appReducer from "./reducers/AppReducer";
import authReducer from "./reducers/AuthReducer";
import { backDropReducer } from "./reducers/backDropReducer";
import AddCdssSuffixReducer from "./reducers/CdssSuffixReducer";
import conversationalLanguageReducer from "./reducers/ConversationalLanguageReducer";
import EncounterReducer from "./reducers/EncounterReducer";
import licenseReducer from "./reducers/LicensingReducer";
import loaderReducer from "./reducers/loaderReducer";
import NewVisitSelectedReducer from "./reducers/NewVisitSelectedReducer";
import PatientReducer from "./reducers/PatientReducer";
import quickAccessReducer from "./reducers/QuickAccessReducer";
import quickAddDataSlice from "./reducers/quickAddDataSlice";
import recognizerReducer from "./reducers/recognizerReducer";
import recordingStatusReducer from "./reducers/RecordinStatusReducer";
import RegFlowReducer from "./reducers/RegFlowReducer";
import resetConversationReducer from "./reducers/ResetConversationReducer";
import scribeReducer from "./reducers/ScribeReducer";
import searchReducer from "./reducers/SearchReducer";
import StateReducer from "./reducers/StateReducer";
import SubscriptionReducer from "./reducers/SubscriptionReducer";
import TabReducer from "./reducers/TabReducer";
import tempDataReducer from "./reducers/TempDataReducer";
import encounterResetReducer from "./reducers/EncounterResetSlice";
import tokenReducer from "./reducers/TokenReducer";
import CopilotReducer from "./reducers/CopilotReducer";
import { planUsageReducer } from "./reducers/PlanUsageReducer";
import MobileTabReducer from "./reducers/MobileTabReducer";
import consentReducer from "./reducers/Consent";
import { NJTemplateUserReducer } from "./reducers/NJTemplateUserReducer";
import EHRSlice from "./reducers/IntegratedEHRSlice";
import syncReducer from "./reducers/SyncSlice";

export const history = createBrowserHistory();

const secretKey = "hgfyu765uhfhgfgb%$@TGRE^%$#fgedgf";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["app", "tabui", "auth", "patientObj", "encounterObj", "sync"],
  transforms: [
    encryptTransform({
      secretKey,
      onError: function (error) {
        // Handle the error.
      },
    }),
  ],
};

let isDev = true;

if (
  localStorage.getItem("logs") &&
  ![0, 2, 4, 6].includes(Number(localStorage.getItem("logs")))
) {
  isDev = true;
} else {
  isDev = false;
}

const rootReducer = (history) =>
  combineReducers({
    app: appReducer,
    auth: authReducer,
    tabui: TabReducer,
    // appointments: Appointmentsreducer,
    // tasks: Tasksreducer,
    stateReducer: StateReducer,
    router: connectRouter(history),
    patientObj: PatientReducer,
    encounterObj: EncounterReducer,
    backDropEffect: backDropReducer,
    isLoading: loaderReducer,
    search: searchReducer,
    resetConversation: resetConversationReducer,
    recordingStatus: recordingStatusReducer,
    quickAddData: quickAddDataSlice,
    scribe: scribeReducer,
    tempData: tempDataReducer,
    quickAccessDashboard: quickAccessReducer,
    newVisitSelected: NewVisitSelectedReducer,
    regFlow: RegFlowReducer,
    subscription: SubscriptionReducer,
    license: licenseReducer,
    addCdssSuffix: AddCdssSuffixReducer,
    conversationalLangauge: conversationalLanguageReducer,
    token: tokenReducer,
    recognizer: recognizerReducer,
    resetCounter: encounterResetReducer,
    copilot: CopilotReducer,
    planUsage: planUsageReducer,
    mobileTab:  MobileTabReducer,
    consent: consentReducer,
    NJTemplateUser: NJTemplateUserReducer,
    consent: consentReducer,
    connectedEHR: EHRSlice,
    sync: syncReducer,
  });

const persistedReducer = persistReducer(persistConfig, rootReducer(history));

// const preloadedState = {};

let middlewares = [routerMiddleware(history)];
if (isDev) middlewares.push(logger);

const store = configureStore({
  reducer: persistedReducer,
  devTools: isDev,
  middleware: getDefaultMiddleware({
    thunk: true,
    serializableCheck: false,
  }).concat(...middlewares),
  // preloadedState,
});

const persistor = persistStore(store);

export { persistor, store };
